import { Component, Inject, OnInit, ViewEncapsulation, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FuseConfirmationConfig } from '@fuse/services/confirmation';
import { FuseConfirmationConfigCustom } from 'app/models/fuseConfirmationConfigCustom';
import { Modal } from 'app/models/modal';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
    selector: 'app-input-text-modal',
    templateUrl: './input-text-modal.component.html',
    styleUrls: ['./input-text-modal.component.scss'],
    styles: [
        `
        .fuse-confirmation-dialog-panel {

            @screen md {
                @apply w-128;
            }

            .mat-mdc-dialog-container {

                .mat-mdc-dialog-surface {
                    padding: 0 !important;
                }
            }
        }
    `
    ],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class InputTextModalComponent {

    data: FuseConfirmationConfigCustom;
    inputForm: UntypedFormGroup;

    filteredCompanies$: Observable<any[]>;
    isPice: boolean = false;
    rolesList: any[] = [];
    isAdmin: boolean = false;

    constructor(
        private dialogRef: MatDialogRef<InputTextModalComponent>,
        @Inject(MAT_DIALOG_DATA) public dataInput: FuseConfirmationConfigCustom,
        private _formBuilder: UntypedFormBuilder,
        private _changeDetectorRef: ChangeDetectorRef,
    ) {
        console.log(this.dataInput);
    
        if (dataInput) {
            this.data = dataInput;
            this.rolesList = (dataInput as any).roles || [];
            this.isAdmin = (dataInput as any).isAdmin || false;
        }


        let fields: string[];
        if (this.data?.mode === 1) {
            fields = ['name', 'lastname', 'email', 'phone'];
        } else if (this.data?.mode === 2) {
            fields = ['name', 'description', 'generate_with_ai']; // Añadimos description y generate_with_ai en modo 2
        } else {
            fields = ['name'];
        }

        const group: any = {};
        // name siempre requerido
        if (fields.includes('name')) group.name = ['', Validators.required];
        // lastname y email solo requeridos si es modo usuario
        if (fields.includes('lastname')) group.lastname = ['', this.data?.mode === 1 ? Validators.required : []];
        // Email es OPCIONAL - el backend lo auto-genera si no se proporciona
        if (fields.includes('email')) group.email = ['', this.data?.mode === 1 ? [Validators.email] : [Validators.email]];
        if (fields.includes('phone')) group.phone = ['', [Validators.pattern(/^[+]?\d{7,15}$/)]];
        // description solo en modo 2, opcional
        if (fields.includes('description')) group.description = [''];
        if (fields.includes('generate_with_ai')) group.generate_with_ai = [true];

        if (this.data?.companies) {
            group.company_id = [null, Validators.required]; 
        }

        this.inputForm = this._formBuilder.group(group);

        if (this.data?.companies) {
            this.filteredCompanies$ = this.inputForm.get('company_id').valueChanges.pipe(
                startWith(''),
                map(value => {
                    const filterValue = typeof value === 'string' ? value.toLowerCase() : (value?.name ? value.name.toLowerCase() : '');
                    return this.data.companies.filter(c => c.name.toLowerCase().includes(filterValue));
                })
            );
        }

    }

    displayCompanyName(company: any): string {
        return company && company.name ? company.name : '';
    }

    togglePice(): void {
        this.isPice = !this.isPice;
        this.updateValidators();
        this._changeDetectorRef.detectChanges();
    }

    private updateValidators(): void {
        const companyControl = this.inputForm.get('company_id');
        
        if (this.isPice) {
            companyControl?.clearValidators();
            companyControl?.setValidators([]);
        } else {
            companyControl?.clearValidators();
            companyControl?.setValidators([Validators.required]);
        }
        companyControl?.updateValueAndValidity();
    }

    showCompanyField(): boolean {
        return !this.isPice;
    }

    get validate(): boolean {
        if (!this.inputForm.valid) return false;
        
        if (this.data?.companies && !this.isPice) {
            const companyValue = this.inputForm.get('company_id').value;
            if (!companyValue || typeof companyValue === 'string') {
                return false;
            }
        }

        return true;
    }

    closeDialog() {
        const value = this.inputForm.value;
        
        // Solo ADMIN puede especificar id_role
        if (this.isAdmin) {
            if (this.isPice) {
                // Crear PICE
                const piceRole = this.rolesList?.find(r => r.tag === 'consultor-pice' || r.tag === 'consultor_pice');
                value.id_role = piceRole?.id;
                value.is_pice = true;
                delete value.company_id;
            } else {
                // Crear empleado regular con company_id
                const empRole = this.rolesList?.find(r => r.tag === 'professional-business');
                value.id_role = empRole?.id;
                if (value.company_id) {
                    value.companies = [value.company_id];
                    delete value.company_id;
                }
            }
        } else {
            // PICE u otro rol no ADMIN: no enviar id_role, dejar que backend lo asigne
            delete value.id_role;
            if (value.company_id) {
                value.companies = [value.company_id];
                delete value.company_id;
            }
        }
        
        // Si solo hay 'name' y nada más, devuelve el string
        if (Object.keys(value).length === 1 && value.name) {
            this.dialogRef.close(value.name);
        } else {
            this.dialogRef.close(value);
        }
    }
}
